import React from "react";
import PropTypes from "prop-types";

class PartPaymentInformation extends React.Component {
  renderCollectorWidgetScript = () => {
    const { walleyWidgetToken, walleyWidgetSrc, amount, channelId } =
      this.props;

    const getDataLang = () => {
      switch (channelId.toString()) {
        // SKBV
        case "1":
        case "2":
          return "sv-SE";
        // GF
        case "4":
        case "9":
          return "nb-NO";
        // NR FI sv
        case "7":
          return "sv-FI";
        // NR FI fi
        case "8":
          return "fi-FI";
        default:
          return null;
      }
    };

    const currentScriptElement = document.getElementById(
      "collector-widget-script"
    );

    if (currentScriptElement) {
      currentScriptElement.parentNode.removeChild(currentScriptElement);
    }

    const script = document.createElement("script");

    script.setAttribute("id", "collector-widget-script");
    script.setAttribute("src", walleyWidgetSrc);
    script.setAttribute("data-token", walleyWidgetToken);
    script.setAttribute("data-widget", "part-payment");
    script.setAttribute("data-amount", amount);
    script.setAttribute("data-container-id", "collector-widget-container");
    script.setAttribute("data-lang", getDataLang());

    document.body.appendChild(script);
  };

  // Does not occur when quantity is updated for WDW
  componentDidMount() {
    this.renderCollectorWidgetScript();
  }

  componentDidUpdate() {
    const currentScript = document.getElementById("collector-widget-script");

    currentScript.setAttribute("data-amount", this.props.amount);
    
    window.walley?.checkout.api.update();
  }

  render() {
    const { aliasPartPaymentInformation } = this.props;

    return (
      <div className="part-payment-information">
        {aliasPartPaymentInformation && (
          <span className="additional-campaign-text">
            {aliasPartPaymentInformation}
          </span>
        )}
        <div
          id="collector-widget-container"
          className="collector-widget-container"
        />
      </div>
    );
  }
}

PartPaymentInformation.propTypes = {
  aliasPartPaymentInformation: PropTypes.string.isRequired,
};

export default PartPaymentInformation;
